/**
 * Extracts initials from a user's name
 * @param name - User's full name
 * @param maxLength - Maximum number of initials to return (default: 2)
 * @returns Uppercase initials string
 */
export const getInitials = (name: string, maxLength = 2): string => {
  if (!name || !name.trim()) return "";

  return name
    .split(" ")
    .map((part) => part[0])
    .join("")
    .toUpperCase()
    .slice(0, maxLength);
};
